import { render, staticRenderFns } from "./ParcelshopList.vue?vue&type=template&id=15cd46b5&scoped=true"
import script from "./ParcelshopList.vue?vue&type=script&lang=js"
export * from "./ParcelshopList.vue?vue&type=script&lang=js"
import style0 from "./ParcelshopList.vue?vue&type=style&index=0&id=15cd46b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../tracking/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cd46b5",
  null
  
)

export default component.exports